export const MATCH_CHIPS_VISIBLE_LIMIT = 3

export const QA_NAME_MATCH_CHIPS_CELL = 'matchChipsCell'
